import {
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { useParams } from "react-router-dom";

const Services = ({ data }) => {
  const { id } = useParams();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(data?.pagination?.current_page - 1);
  const [isLoading, setIsLoading] = useState(false);
  const [servicesData, setServicesData] = useState(data.services);
  const [paginationServicesData, setPaginationServicesData] = useState(
    data?.pagination
  );
  const [dataTable, setDataTable] = useState(
    servicesData.map((panel) => ({
      id: panel.id,
      name: panel.name,
      panelUrl: panel.panelUrl,
      rate_per_1000: panel.rate_per_1000,
      rate: panel.rate,
      order_range: `${panel.min_order} / ${panel.max_order}`,
      category: panel.category,
    }))
  );
  const columns = [
    { id: "id", label: "ID", minWidth: 50 },
    { id: "name", label: "Service", minWidth: 100 },
    { id: "rate", label: "Rate", minWidth: 50 },
    { id: "order_range", label: "Min & Max", minWidth: 100 },
    { id: "category", label: "Category", minWidth: 200 },
  ];

  const getData = async () => {
    setIsLoading(true);
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Panels.GetOne}${id}?per_page=${limit}&page=${
          page + 1
        }`,
      });

      if (response) {
        setServicesData(response?.data?.services);
        setPaginationServicesData(response?.data?.pagination);
        setDataTable(
          response?.data?.services.map((panel) => ({
            id: panel.id,
            name: panel.name,
            panelUrl: panel.panelUrl,
            rate_per_1000: panel.rate_per_1000,
            rate: panel.rate,
            order_range: `${panel.min_order} / ${panel.max_order}`,
            category: panel.category,
            action: (
              <Typography style={{ color: "#2F64AE" }}>Review</Typography>
            ),
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (page !== paginationServicesData?.current_page - 1) {
      getData();
    }
    if (limit !== servicesData?.length) {
      getData();
    }
  }, [page, limit]);

  return (
    <Box sx={{ padding: "30px" }}>
      <Typography
        sx={{
          fontSize: "35px",
          lineHeight: "40px",
          fontWeight: "700",
          marginBottom: "20px",
        }}
      >
        Panel Services
      </Typography>
      <Card>
        <CardContent>
          {isLoading && <LinearProgress />}
          {servicesData?.length > 0 ? (
            <>
              <TableContainer>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column, index) => (
                        <TableCell
                          key={column.id}
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            border: "1px solid #00000080",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                      >
                        {columns.map((column, index) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              style={{
                                border: "1px solid #00000080",
                              }}
                            >
                              {column.id === "action"
                                ? value
                                : typeof value === "string"
                                ? value.slice(0, 50)
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <TablePagination
                  rowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                  count={paginationServicesData?.total}
                  rowsPerPage={limit}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleLimitChange}
                  sx={{
                    "& .MuiTablePagination-toolbar": {
                      justifyContent: "space-between",
                      width: "100%",
                      padding: 0,
                    },
                    "& .MuiTablePagination-actions": {
                      display: "flex",
                      justifyContent: "flex-end",
                      "& .MuiIconButton-root": {
                        margin: "0 4px",
                        borderRadius: "0%",
                        "& svg": {
                          fontSize: "2rem",
                        },
                      },
                    },
                    "& .MuiTablePagination-selectLabel": {
                      color: "#004571",
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                    },
                    "& .MuiInputBase-root": {
                      borderRadius: "4px",
                      padding: "4px",
                      marginLeft: "8px",
                      "& .MuiSelect-select": {
                        color: "#004571",
                        padding: "4px 20px 4px 8px",
                        fontWeight: "bold",
                      },
                    },
                    "& .MuiTablePagination-displayedRows": {
                      color: "#004571", // Customize text color
                      fontSize: "0.875rem", // Adjust font size
                      fontWeight: "bold", // Make text bold
                      marginRight: "16px", // Add some spacing on the right if needed
                    },
                  }}
                />
              </Box>
            </>
          ) : (
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "40px",
                fontWeight: "500",
                color: "#494949",
                marginTop: "20px",
              }}
            >
              There are no item yet
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Services;
